module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_03-74dfe982ca548352e535db88fda64a84.jpg";